(() => {
  function initialize(root) {
    if (root.dataset.mcInitialized === 'true') return;
    root.dataset.mcInitialized = 'true';
    const filters = root.querySelector('[data-mc-filters]');
    const cards = Array.from(root.querySelectorAll('[data-mc-card]'));
    const buttons = Array.from(root.querySelectorAll('[data-mc-filter]'));
    const count = root.querySelector('[data-mc-count]');
    const empty = root.querySelector('[data-mc-empty]');
    if (!filters || !count || !empty) return;
    filters.hidden = cards.length === 0;
    function applyFilter(value) {
      let visible = 0;
      cards.forEach(card => {
        const show = value === 'all' || card.dataset.mcKind === value;
        card.hidden = !show;
        if (show) visible += 1;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mcFilter === value)));
      count.textContent = `${visible} ${visible === 1 ? root.dataset.countOne : root.dataset.countMany}`;
      empty.hidden = visible !== 0 || cards.length === 0;
    }
    buttons.forEach(button => button.addEventListener('click', () => applyFilter(button.dataset.mcFilter)));
    applyFilter('all');
  }
  document.querySelectorAll('[data-melt-christmas]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-melt-christmas]').forEach(initialize);
  });
})();
